import React from 'react';
export const UploadSVG = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className="mx-auto h-12 w-12"
			viewBox="0 0 20 20"
			fill="currentColor"
		>
			<path
				fillRule="evenodd"
				d="M6 2a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7.414l-2-2V4a1 1 0 00-1-1H6zm6 5a1 1 0 100-2 1 1 0 000 2z"
				clipRule="evenodd"
			/>
		</svg>

	)
}